module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/chevron-right-double-ef1075c70528bdd55920b7f676e134b3.svg";